import React from 'react';
import {
  Container, Typography, Grid, Card, CardContent, Box, List,
  ListItem, ListItemIcon, ListItemText, Paper, Button
} from '@mui/material';
import { Link as RouterLink } from 'react-router-dom';
import CheckCircleIcon from '@mui/icons-material/CheckCircle';
import DevicesIcon from '@mui/icons-material/Devices';
import PolicyIcon from '@mui/icons-material/Policy';
import CloudSyncIcon from '@mui/icons-material/CloudSync';
import VerifiedIcon from '@mui/icons-material/Verified';

const services = [
  'Microsoft Intune deployment and administration',
  'Windows Autopilot zero-touch provisioning',
  'Device enrollment and compliance policies',
  'Configuration profiles and application deployment',
  'Conditional access policy setup',
  'Mobile Device Management (MDM)',
  'Endpoint analytics and reporting',
  'PowerShell automation for endpoint provisioning',
  'Patch management and update policies',
  'Antivirus and security baseline enforcement',
  'Device lifecycle management (500+ endpoints)',
  'Compliance reporting for management',
];

const benefits = [
  {
    icon: DevicesIcon,
    title: 'Intune Expert',
    description: 'Deployed and administered Intune across 500+ endpoints in enterprise environments',
  },
  {
    icon: CloudSyncIcon,
    title: 'Autopilot Ready',
    description: 'Windows Autopilot setup for zero-touch device onboarding and provisioning',
  },
  {
    icon: PolicyIcon,
    title: 'Policy Management',
    description: 'Compliance, configuration, and conditional access policies tailored to your needs',
  },
  {
    icon: VerifiedIcon,
    title: 'PowerShell Automation',
    description: 'Custom scripts to streamline provisioning, enforcement, and reporting',
  },
];

function EndpointManagement() {
  return (
    <Box sx={{ py: 6, bgcolor: 'background.default' }}>
      <Container maxWidth="lg">
        <Box sx={{ textAlign: 'center', mb: 8 }}>
          <Typography variant="h2" component="h1" className="gradient-text" sx={{ mb: 3 }}>
            Endpoint Management
          </Typography>
          <Typography variant="h5" sx={{ color: 'text.secondary', mb: 4 }}>
            Microsoft Intune, Autopilot, and device lifecycle management for your organization
          </Typography>
          <Button
            component={RouterLink}
            to="/booking"
            variant="contained"
            size="large"
            sx={{
              py: 2, px: 4, fontSize: '1.2rem',
              background: 'linear-gradient(45deg, #2563eb 30%, #3b82f6 90%)',
              '&:hover': { background: 'linear-gradient(45deg, #3b82f6 30%, #2563eb 90%)' }
            }}
          >
            Schedule Consultation
          </Button>
        </Box>

        <Grid container spacing={4} sx={{ mb: 8 }}>
          {benefits.map((benefit, index) => (
            <Grid item xs={12} sm={6} md={3} key={index}>
              <Card className="glass-effect card-hover" sx={{ height: '100%' }}>
                <CardContent sx={{ textAlign: 'center', height: '100%', display: 'flex', flexDirection: 'column', justifyContent: 'center' }}>
                  <Box sx={{ mb: 2, color: 'primary.main' }}>
                    {React.createElement(benefit.icon, { sx: { fontSize: 40 } })}
                  </Box>
                  <Typography variant="h6" gutterBottom>{benefit.title}</Typography>
                  <Typography variant="body2" color="text.secondary">{benefit.description}</Typography>
                </CardContent>
              </Card>
            </Grid>
          ))}
        </Grid>

        <Paper elevation={3} sx={{ p: 4, background: 'rgba(255,255,255,0.05)', backdropFilter: 'blur(10px)' }}>
          <Typography variant="h4" gutterBottom sx={{ mb: 4 }}>Endpoint Services Offered</Typography>
          <Grid container spacing={2}>
            {services.map((service, index) => (
              <Grid item xs={12} sm={6} key={index}>
                <List>
                  <ListItem>
                    <ListItemIcon><CheckCircleIcon color="primary" /></ListItemIcon>
                    <ListItemText primary={service} />
                  </ListItem>
                </List>
              </Grid>
            ))}
          </Grid>
        </Paper>
      </Container>
    </Box>
  );
}

export default EndpointManagement;
